module.exports = __webpack_public_path__ + "img/icon_sm_xsyysh.64595bcc.png";